import { clx, ControlledRadioGroup } from "@hm/fundamental"
import { useLayoutEffect, useRef } from "react"

interface RadioOption {
	value: string
	label?: string
	subLabel?: string
	children?: React.ReactNode
}

interface BaseControlledRadioGroupProps<T extends string = string> {
	name: string
	value: T
	onChange: (value: T) => void
	options?: RadioOption[]
	children?: React.ReactElement[]
	className?: string
	"data-cy"?: string
}

export const BaseControlledRadioGroup = <T extends string = string>({
	name,
	className,
	value,
	onChange,
	...rest
}: BaseControlledRadioGroupProps<T>): React.ReactElement => {
	const ref = useRef<HTMLDivElement>(null)

	useLayoutEffect(() => {
		ref.current
			?.querySelectorAll<HTMLInputElement>('input[type="radio"]')
			.forEach(radio => {
				radio.name = name
			})
	})

	return (
		<div ref={ref}>
			<ControlledRadioGroup
				{...rest}
				value={value as string}
				onChange={onChange as (value: string) => void}
				className={clx(
					"[&>tr]:border-b-solid [&>tr]:border-b-[1px]",
					className,
				)}
			/>
		</div>
	)
}
